import React from 'react';
import TimelineStep from '#component/shipment/overview/shipment-timeline/timeline-step';

export default ({ checkpoint, index, checkpoints, account }) =>
  <div style={{ maxWidth: 250, fontSize: 14, fontWeight: 400, lineHeigth: '1.43em' }}>
    <TimelineStep
      state={checkpoint}
      index={index}
      states={checkpoints}
      account={account}
      showInTooltip={true}
    />
  </div>;
